import React from 'react';
import { Col, Row } from 'react-bootstrap';

import tatjanaLalkovic from '../../../assets/images/tatjanaLalkovic.png';

const WelcomingAMember = () => {
  return (
    <Col>
      <h4
        // className="carouselValueTitle"
        style={{
          textAlign: 'center'
        }}>
        Welcoming a New CSIO Board Member
          </h4>
      <Row style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20
      }}>
          <img
            src={tatjanaLalkovic}
            style={{
              height: '100%',
              width: 'auto',
              margin: 10
              // maxHeight: 140
            }}
            aria-label="profile picture of Tatjana Lalkovic"
            />
            <div className="welcomeNewMemberText" style={{backgroundColor: '#F3F5ED', padding: 26, maxWidth: 480, margin: 10}} >
            {/* This year, CSIO welcomed <span style={{ color: '#00536E' }}>Tatjana Lalkovic</span>, Senior Vice President and Chief Information Officer at Economical Insurance to the Board. */}
            This year, CSIO welcomed <span style={{ color: '#00536E' }}>Tatjana Lalkovic</span>, Senior Vice President and Chief Information Officer at Economical Insurance, to the Board of Directors.
            </div>
      </Row>
    </Col>
  )
}

export default WelcomingAMember;
